import { MAIN_PLAYER_TOGGLE, NOTIFICATION, SIDEBAR_OPEN, VOLUME_TOGGLE } from "../types/styles";

export const setsidebarOpen = (isOpen) => async (dispatch) => {
  dispatch({ type: SIDEBAR_OPEN, payload: isOpen });
};

export const mainPlayerToggle = (isOpen) => async (dispatch) => {
  dispatch({ type: MAIN_PLAYER_TOGGLE, payload: isOpen });
};

export const volumeToggle = (isOpen) => async (dispatch) => {
  dispatch({ type: VOLUME_TOGGLE, payload: isOpen });
};

export const setNotification = (notification) => async (dispatch) => {
  dispatch({ type: NOTIFICATION, payload: notification });
};
